import { LoadingService } from 'src/app/core/layout/services/loading.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { AccountBalanceService } from '@wlp/ui-bs-cashin';
import { ExtractService, TransferService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UICHeaderUserInfoService } from '@wlp/ui-c-header-user-info';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';

@Component({
  selector: 'ui-t-detran-receipt',
  templateUrl: './detran-receipt.page.html',
  styleUrls: ['./detran-receipt.page.scss'],
})
export class ReceiptDetranPage implements OnInit {
  public transferDataReceipt: any;
  private userProfile: UserInfoProfile;
  public scheduling: boolean;

  title: string;

  public brand: string;
  confirmation: any;
  isReceipt: boolean = false;
  transactionId: any;


  constructor(
    private accountBalanceService: AccountBalanceService,
    private transferService: TransferService,
    protected userInfoService: UserInfoService,
    protected extractService: ExtractService,
    private headerService: UICHeaderUserInfoService,
    public activatedRoute: ActivatedRoute,
    private layoutConfigService: LayoutConfigService,
    private router: Router,
    public loadingService:LoadingService
  ) {
    this.brand = this.layoutConfigService.getConfig('wlTheme.header.brand.logo.primary');
  }

  ngOnInit() {
    this.isReceipt = true;
    this.loadUser();
    if (this.router.getCurrentNavigation().extras.state == undefined) {
      this.router.navigate(['/app/payment/detran/consult']);
    } else {
      this.transactionId = this.router.getCurrentNavigation().extras.state.transactionId;
    }
    this.getTransaction(this.transactionId);
  }



  loadUser() {
    try {
      const userDetails = this.userInfoService.getInfoProfile();
      userDetails.then((user) => {
        this.userProfile = user;
      });
    } catch (e) {
      console.error('Failed to load user details', e);
    }
  }

  getTransaction(transactionId: string) {
    this.extractService.getTransaction(transactionId).subscribe((res) => {
      this.confirmation = res;
      this.title = 'Pagamento Detran'
    });
  }
}
